import { Auth } from "aws-amplify";
import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { route } from "../routes";
import {
  userDataState,
  userFavoriteBondsState,
  userCustomerApplicationState,
  userCustomerApplicationWizardState,
  userAuthState,
} from "../state";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
  const [, setUserAuthData] = useRecoilState(userAuthState);
  const [, setUserDataState] = useRecoilState(userDataState);
  const [, setUserFavoriteBondsState] = useRecoilState(userFavoriteBondsState);
  const [, setUserCustomerApplicationState] = useRecoilState(userCustomerApplicationState);
  const [, setUserCustomerApplicationWizardState] = useRecoilState(userCustomerApplicationWizardState);

  const navigate = useNavigate();

  // rome-ignore lint/nursery/useExhaustiveDependencies: <explanation>
  return useCallback(async () => {
    Auth.signOut();
    setUserAuthData(null);
    setUserDataState(null);
    setUserFavoriteBondsState([]);
    setUserCustomerApplicationState(null);
    setUserCustomerApplicationWizardState(null);
    navigate(route.signIn());
  }, [
    setUserAuthData,
    setUserDataState,
    setUserFavoriteBondsState,
    setUserCustomerApplicationState,
    setUserCustomerApplicationWizardState,
    // navigate, <--- Intentionally NOT, this will cause infinite loop of redirects
  ]);
};
